define('lq/dayTime',[
    'jquery'
], function ($) {
    'use strict';
    
    var fixBetween = function (value, min, max) {
        return Math.max(min, Math.min(value, max));
    };

    var getHoursAndMinutes = function (dayTimeString) {
        dayTimeString = dayTimeString || null;
        if (dayTimeString == null) {
            return null;
        }

        var parts = dayTimeString.split(':', 2);
        var hourPart;
        var minutePart;
        if (parts.length == 1) {
            hourPart = dayTimeString.substr(0, Math.min(dayTimeString.length, 2));
            minutePart = dayTimeString.length > 2 ? dayTimeString.substr(2, Math.min(dayTimeString.length - 2, 2)) : '00';
        } else {
            hourPart = parts[0];
            minutePart = parts[1];
        }

        if ($.isNumeric(hourPart)) {
        } else if (hourPart.length == 0) {
            hourPart = 0;
        } else {
            return null;
        }

        if ($.isNumeric(minutePart)) {
        } else if (minutePart.length == 0) {
            minutePart = 0;
        } else {
            return null;
        }

        hourPart = $.isNumeric(hourPart) ? hourPart : 0;
        minutePart = $.isNumeric(minutePart) ? minutePart : 0;

        return {
            hours: hourPart,
            minutes: minutePart
        }
    };

    var toTimeString = function(hours, minutes) {
        var stringSingsTwo = function (val) {
            var result = val.toString();
            while (result.length < 2) {
                result = '0' + result;
            }
            return result;
        };
        return stringSingsTwo(hours) + ':' + stringSingsTwo(minutes);
    };

    return {
        fromTicks: function (ticks) {
            if (!ticks && ticks !== 0) {
                return '--:--';
            }
            var hours = Math.floor(ticks / 3600);
            var minutes = Math.floor((ticks - hours * 3600) / 60);
            return toTimeString(hours, minutes);
        },

        fromDate: function (piping, dateString) {
            if (!dateString) {
                return '--:--';
            }
            // WHY calendar parameters are Date objects that hold the wall-clock time in their UTC fields (see calendarParameter.convert)
            if (dateString instanceof Date) {
                return toTimeString(dateString.getUTCHours(), dateString.getUTCMinutes());
            }
            var date = piping.formatting.createFormatter().parseLicquidDate(dateString);
            if (date == null) {
                throw "The value '" + dateString + "' is not a valid date/time";
            }
            return toTimeString(date.getHours(), date.getMinutes());
        },

        toTicks: function (dayTimeString) {
            var hoursAndMinutes = getHoursAndMinutes(dayTimeString);
            if (hoursAndMinutes == null) return null; 
            return fixBetween(hoursAndMinutes.hours, 0, 23) * 3600 + fixBetween(hoursAndMinutes.minutes, 0, 59) * 60;
        },

        toDate: function (piping, dayTimeString) {
            var hoursAndMinutes = getHoursAndMinutes(dayTimeString);
            if (hoursAndMinutes == null) return null;
            var date = new Date(1753, 1, 1, hoursAndMinutes.hours, hoursAndMinutes.minutes, 0);
            return piping.formatting.createFormatter().formatLicquidDate(date);
        }
    };
});
